import styled from "styled-components";

export const NoteText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 8px;
  text-align: center;
  font-family: "San Francisco Text";

  &.custom-description {
    margin-bottom: 3px;
  }
`;
